import { ItemTypeEnum } from '@share/common-types';
import { CATALOG_ITEM_TYPE_PARAM, ITEM_TYPE_OPTIONS } from './constants';

const VALID_ITEM_TYPES = new Set<string>(Object.values(ItemTypeEnum));

export const parseItemTypesFromSearch = (search: string): ItemTypeEnum[] => {
  const params = new URLSearchParams(search);
  const value = params.get(CATALOG_ITEM_TYPE_PARAM);
  if (!value || !VALID_ITEM_TYPES.has(value)) {
    return [];
  }
  return [value as ItemTypeEnum];
};

const isAllSelected = (selected: ItemTypeEnum[]): boolean => {
  return selected.length === 0;
};

export const toggleFilter = (
  current: ItemTypeEnum[],
  option: (typeof ITEM_TYPE_OPTIONS)[number],
): ItemTypeEnum[] => {
  if (option.key === 'all') {
    return [];
  }
  const hasType = current.includes(option.key);
  if (hasType) {
    const next = current.filter((t) => t !== option.key);
    return next;
  }
  return [...current, option.key];
};

export const isFilterActive = (
  option: (typeof ITEM_TYPE_OPTIONS)[number],
  selected: ItemTypeEnum[],
): boolean => {
  if (option.key === 'all') {
    return isAllSelected(selected);
  }
  return selected.includes(option.key);
};
